import { ApiProperty } from "@nestjs/swagger";

export class subplantReportRequest {
    @ApiProperty()
    fromDate?: Date;
    @ApiProperty()
    toDate?: Date;
    @ApiProperty()
    plantName: string;
    @ApiProperty()
    operation: string;
    @ApiProperty()
    lotNumber: string;
    @ApiProperty()
    soNumber: string;
    @ApiProperty()
    jobNumber: string;

}